import React from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Typography, Button, Avatar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import Icon from '@bit/amazingdesign.react-redux-mui-starter.icon'
// NavList i LanguageSwitcher z wnętrza Kit, żeby menu profilu było tym samym komponentem co w nagłówku Kit 0.0.12
import NavList from '@bit/amazingdesign.react-redux-mui-starter.kit/dist/NavList'
import LanguageSwitcher from '@bit/amazingdesign.react-redux-mui-starter.kit/dist/LanguageSwitcher'

export const PROFILE_MENU_ID = 'menu-profilu'
// Font Awesome 5 Solid jak pozycje menu bocznego; ta sama ikona co „Użytkownicy” (isa-surveys-backend, users.service.js)
export const PROFILE_ICON = 'fas fa-user'

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
  },
  avatar: {
    width: 24,
    height: 24,
  },
  label: {
    marginLeft: theme.spacing(1),
    // 16 px jak przełącznik języka i pozycje menu (przycisk MUI ma domyślnie 14 px)
    fontSize: theme.typography.body1.fontSize,
    // Poniżej 600 px sama ikona, nazwę przycisku daje aria-label (decyzja właściciela 2026-10-15)
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}))

// Zastępuje nagłówek Kit (przekazywany przez adminProps.header): zamiast pustego szarego kółka Avatar
// przycisk z ikoną postaci (z tej samej rodziny co menu boczne) i napisem „Profil” (t('Profile')).
const Header = ({ label, routes, languages, userAvatarSrc }) => {
  const classes = useStyles()
  const { t } = useTranslation(undefined, { useSuspense: false })
  const [anchorEl, setAnchorEl] = React.useState(null)
  const currentPath = useSelector((state) => state.router.location.pathname)

  const onOpen = (event) => setAnchorEl(event.currentTarget)
  const onClose = () => setAnchorEl(null)

  return (
    <>
      <Typography variant={'h6'} noWrap={true} style={{ flexGrow: 1 }}>
        {label}
      </Typography>
      {
        languages ?
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <LanguageSwitcher color={'white'} noLabel={true} languages={languages} />
          </div>
          :
          null
      }
      <Button
        color={'inherit'}
        className={classes.button}
        aria-label={t('Profile')}
        aria-controls={PROFILE_MENU_ID}
        aria-haspopup={'true'}
        aria-expanded={Boolean(anchorEl)}
        onClick={onOpen}
      >
        {
          userAvatarSrc ?
            <Avatar src={userAvatarSrc} alt={''} className={classes.avatar} />
            :
            <Icon>{PROFILE_ICON}</Icon>
        }
        <span className={classes.label}>{t('Profile')}</span>
      </Button>
      <NavList
        id={PROFILE_MENU_ID}
        currentPath={currentPath}
        routes={routes}
        isMenu={true}
        isNestedMenu={true}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        onClick={onClose}
      />
    </>
  )
}

Header.propTypes = {
  label: PropTypes.node,
  routes: PropTypes.array,
  languages: PropTypes.arrayOf(PropTypes.exact({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  userAvatarSrc: PropTypes.string,
}

export default Header
